import standardApiRequestAction from 'my-core/standardApiRequestAction';

export function createQuestionSubmission(params) {
  return standardApiRequestAction({
    path: '/api/v1/quiz_question_submissions/create_question_submission',
    method: 'post',
    body: params,
  });
}

export function createQuizSubmissions(params) {
  return standardApiRequestAction({
    path: '/api/v1/quiz_question_submissions/create_quiz_submissions',
    method: 'post',
    body: { ts: Date.now(), ...params },
  });
}

export function clearForQuiz(quizId, onlineCourseId) {
  return standardApiRequestAction({
    path: `/api/v1/quiz_question_submissions/for_quiz/${quizId}`,
    method: 'delete',
    body: { online_course_id: onlineCourseId },
  });
}

export function deleteQuizSubmissionAttempt({ quizId, ts, userId }) {
  return standardApiRequestAction({
    path: '/api/v1/quiz_question_submissions/delete_quiz_submission_attempt',
    method: 'delete',
    body: { user_id: userId, quiz_id: quizId, ts },
  });
}

export function updateQuizSubmissionState(quizId, onlineCourseId, state) {
  return standardApiRequestAction({
    path: `/api/v1/quiz_question_submissions/update_quiz_state/${quizId}`,
    method: 'patch',
    body: { online_course_id: onlineCourseId, state: { ...state, updated_ts: Date.now() } },
  });
}

export function savePracticeModeQuizQuestionSubmission(ocId, sectionId, quizQuestionId, submission, params) {
  return standardApiRequestAction({
    path: '/api/v1/quiz_question_submissions/practice_mode_save',
    method: 'put',
    body: {
      section_id: sectionId,
      quiz_question_id: quizQuestionId,
      online_course_id: ocId,
      submission,
      ...params,
    },
  });
}

export function clearOnlineCoursePracticeMode(onlineCourseId) {
  return standardApiRequestAction({
    path: '/api/v1/quiz_question_submissions/practice_mode_reset',
    method: 'put',
    body: { online_course_id: onlineCourseId },
  });
}

export function resetQuizQuestionSubmission(id) {
  return standardApiRequestAction({
    path: `/api/v1/quiz_question_submissions/${id}/reset`,
    method: 'delete',
  });
}

export function fetchQuizUserSubmissions(quizId, userId, params, requestKey) {
  return standardApiRequestAction({
    path: '/api/v1/quiz_question_submissions/for_quiz',
    requestKey,
    body: { ...params, quiz_id: quizId, user_id: userId },
  });
}

export function submitLsatPracticeTestResults(quizId, body) {
  return standardApiRequestAction({
    path: `/api/v1/lsat/submit_practice_test_results/${quizId}`,
    method: 'put',
    body,
  });
}
